exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-center[data-v-ff7c3976] {\n  display: inline-block;\n}", ""]);

// exports
